import Vue from 'vue';
import moment from 'moment';
import {
  getField,
  updateField,
} from 'vuex-map-fields';

import {
  GETTER_PROGRAM_QUESTIONS,
  GETTER_SUBMIT_PROGRAM_BODY,
  GETTER_COUPON_FILEID,
  ACTION_SET_ANSWER,
  ACTION_RESET_PROGRAM_STATE,
  MUTATE_SET_ANSWER,
  MUTATE_RESET_PROGRAM_STATE,
} from './types';
import store from '@/store';

import {getPrescriptionCoupon} from '@/utils/medicine';


const defaultState = () => ({
  coupon: null,
  program: null,
  respondent: {
    firstname: '',
    middlename: '',
    lastname: '',
    birthdate: '',
    gender: null,
    email: '',
    mobilenumber: '',
    address: {
      city: '',
      street: '',
    },
  },
  captchatoken: null,
  accesstoken: null,
  source: 'web',
  termsAgreed: true,
  privacyAgreed: true,
  loadingstate: false,
  uploadid: null,
});

const state = defaultState();

const getters = {
  getField,
  [GETTER_PROGRAM_QUESTIONS]: ({program}) => program.questions,
  [GETTER_COUPON_FILEID]: ({coupon, uploadid}) => {
    //if coming from pharmacy-order (medicine-order-details-program-freestylelibre)
    if (coupon.uploadid) {
      return coupon.uploadid;
    }

    //if coming from messages
    if (uploadid) {
      return uploadid;
    }

    const matchedFile = store.getters.GETTER_FILES.find(file => {
      if (file.coupons) {
        return getPrescriptionCoupon(file).couponid === coupon.couponid;
      }

      return false;
    });

    return matchedFile ? matchedFile.uploadid : '';
  },
  [GETTER_SUBMIT_PROGRAM_BODY]: ({coupon, program, respondent, captchatoken, source}, getters) => {
    return {
      captchatoken,
      source,
      ...respondent,
      questionnaire_id: program.questionnaire_id,
      birthdate: moment(respondent.birthdate).format('YYYY-MM-DD[T00:00:00.000Z]'),
      responses: program.questions,
      coupons: [{
        couponid: coupon.couponid,
        fileid: getters[GETTER_COUPON_FILEID],
        source: 'smd',
        availmentcode: coupon.availmentcode,
      }],
    }
  },
}

const actions = {
  [ACTION_SET_ANSWER]({commit}, answer) {
    commit(MUTATE_SET_ANSWER, answer);
  },
  [ACTION_RESET_PROGRAM_STATE]({commit}) {
    commit(MUTATE_RESET_PROGRAM_STATE);
  }
}

const mutations = {
  updateField,
  [MUTATE_SET_ANSWER](state, {question_number, answer}) {
    const {questions} = state.program;
    const questionIndex = questions.findIndex(q => q.question_number === question_number);
    const questionType = questions[questionIndex].question_type;

    let questionAnswer;
    if (questionType === 'radio') {
      questionAnswer = answer;
    } else {
      questionAnswer = {
                        ...questions[questionIndex].choices[0],
                        remarks: answer,
                       }
    }

    Vue.set(
      state.program.questions,
      questionIndex,
      {
        ...state.program.questions[questionIndex],
        chosen_answer: questionAnswer,
      },
    );
  },
  [MUTATE_RESET_PROGRAM_STATE](state) {
    Object.assign(state, defaultState());
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
